"use client";

import { c as _c } from "react/compiler-runtime";
import { useAIChatInputFileContext } from "../contexts";
import { useId } from "react";
import { HiOutlinePaperClip } from "react-icons/hi";
interface AIChatInputFileUploadProps {
  className?: string;
}

/**
 * Paperclip file picker. Must be rendered inside an AIChat.Input.DropZone,
 * which provides the accept / maxSize configuration and validated handler.
 */
export function AIChatInputFileUpload(t0) {
  const $ = _c(15);
  const {
    className
  } = t0;
  const fileInputId = useId();
  const {
    accept,
    handleFiles
  } = useAIChatInputFileContext();
  let t1;
  if ($[0] !== accept) {
    t1 = accept?.join(",");
    $[0] = accept;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== handleFiles) {
    t2 = e => {
      const files = e.target.files;
      if (!files || files.length === 0) {
        return;
      }
      handleFiles(Array.from(files));
      e.target.value = "";
    };
    $[2] = handleFiles;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== fileInputId || $[5] !== t1 || $[6] !== t2) {
    t3 = <input id={fileInputId} type="file" multiple={true} accept={t1} onChange={t2} className="hidden" />;
    $[4] = fileInputId;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <HiOutlinePaperClip size={20} className="text-primary" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== fileInputId) {
    t5 = <label htmlFor={fileInputId} className="shrink-0 cursor-pointer">{t4}</label>;
    $[9] = fileInputId;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== className || $[12] !== t3 || $[13] !== t5) {
    t6 = <div className={className}>{t3}{t5}</div>;
    $[11] = className;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}